import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { mdiAccountMultiple, mdiDoorOpen } from '@mdi/js'
import Tooltip from '@material-ui/core/Tooltip'

import Link from '../controls/Link'
import EditButton from './EditButton'

const CommunityRow = (p) => (
  <TableRow>
    <TableCell>
      <Link to={`/communities/${p.community.id}`}>{p.community.id}</Link>
    </TableCell>
    <TableCell>{p.community.name}</TableCell>
    <TableCell>{p.community.organization_id || ''}</TableCell>
    <TableCell>{p.community.location.address}</TableCell>
    <TableCell>
      <Tooltip title={`${p.community.name} Users`} placement="top">
        <span>
          <Link to={`/communities/${p.community.id}/users`}>
            <IconButton aria-label="Users">
              <SvgIcon>
                <path d={mdiAccountMultiple} />
              </SvgIcon>
            </IconButton>
          </Link>
        </span>
      </Tooltip>
      <Tooltip title={`Edit ${p.community.name}`} placement="top">
        <span>
          <EditButton label={`Edit ${p.community.name}`} onClick={() => p.onEdit(p.community)} />
        </span>
      </Tooltip>
      <Tooltip title={`${p.community.name} Door Access`} placement="top">
        <span>
          <Link to={`/communities/${p.community.id}/access`}>
            <IconButton aria-label="Door Access">
              <SvgIcon>
                <path d={mdiDoorOpen} />
              </SvgIcon>
            </IconButton>
          </Link>
        </span>
      </Tooltip>
    </TableCell>
  </TableRow>
)

class CommunityList extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    communities: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
  }

  static styles = {
    table: {
      width: 'auto',
    },
  }

  render() {
    return (
      <Table className={this.props.classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Organization</TableCell>
            <TableCell>Address</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.values(this.props.communities).map((c) => (
            <CommunityRow key={c.id} community={c} {...this.props} />
          ))}
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(CommunityList.styles)(CommunityList)
